import { usePhaseQuery, useCreatePhaseMutation, useUpdatePhaseMutation, useDeletePhaseMutation } from './usePhasesQuery';
import { Phase } from '../types';

export const usePhase = (phaseId?: string) => {
    const { data: record, isLoading: loading, refetch: fetchRecord } = usePhaseQuery(phaseId || '');
    const createPhaseMutation = useCreatePhaseMutation();
    const updatePhaseMutation = useUpdatePhaseMutation();
    const deletePhaseMutation = useDeletePhaseMutation();

    const createRecord = async (values: Phase) => {
        return await createPhaseMutation.mutateAsync(values);
    };

    const updateRecord = async (values: Phase) => {
        if (typeof phaseId === 'undefined') {
            throw new Error('phaseId is required parameter');
        }
        return await updatePhaseMutation.mutateAsync({ id: phaseId, record: values });
    };

    const deleteRecord = async () => {
        if (typeof phaseId === 'undefined') {
            throw new Error('phaseId is required parameter');
        }
        return await deletePhaseMutation.mutateAsync(phaseId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
